document.addEventListener("DOMContentLoaded", () => {
    const forms = document.querySelectorAll(".form-container");

    function checkFiles(uploadField) {
        const uploadedFiles = uploadField.querySelector(".uploaded-files");
        uploadedFiles.innerHTML = '';

        uploadedFiles.addEventListener("click", (e) => {
            e.preventDefault();
        });

        const files = uploadField.querySelector("input").files;
        for (let i = 0; i < files.length; i++) {
            const name = files[i].name;
            const element = document.createElement("span");
            element.innerText = name;

            uploadedFiles.append(element);
        }

        if (files.length > 0) {
            const removeButton = document.createElement("div");
            removeButton.classList.add("remove");
            removeButton.innerText = 'Clear';

            removeButton.addEventListener("click", (e) => {
                e.preventDefault();

                uploadField.querySelector("input").value = '';
                checkFiles(uploadField);
            });

            uploadedFiles.append(removeButton);
        }
    }

    forms.forEach(form => {
        const baseURL = form.getAttribute('data-homepage');

        const uploadFields = form.querySelectorAll(".form-upload");
        uploadFields.forEach(uploadField => {
            uploadField.addEventListener("change", () => checkFiles(uploadField));
        });

        const events = ["keyup", "change"];
        const inputs = form.querySelectorAll(".form-element-group:has(input), .form-element-group:has(textarea)");
        const selects = form.querySelectorAll(".form-element-group:has(select)");

        checkForErrors(inputs, events);
        checkForErrors(selects, ["click"]);

        form.onsubmit = (e) => {
            formOnSubmit(e, form, baseURL);
        };
    });
});

function checkForErrors(inputs, events) {
    inputs.forEach(input => {
        events.forEach(function (e) {
            input.addEventListener(e, () => {
                const characters = input.querySelector(".chars-limit span:first-child");
                const errorState = input.querySelectorAll(".error");

                const text = input.querySelector(".form-element-control");
                if (text) {
                    const value = text.value;

                    if (characters) {
                        characters.innerHTML = value.length;
                    }

                    if (errorState.length > 0) {
                        if (value.length == 0) {
                            errorState[0].classList.add("error-visible");
                        } else {
                            errorState[0].classList.remove("error-visible");
                        }
                    }
                }

                const select = input.querySelector(".select-selected");
                if (select) {
                    if (select.classList.contains("changed-initial-option")) {
                        errorState[0].classList.remove("error-visible");
                    } else {
                        errorState[0].classList.add("error-visible");
                    }
                }
            });
        });
    });
}

function validateForm(inputs) {
    let isValid = true;

    inputs.forEach(input => {
        const characters = input.querySelector(".chars-limit span:first-child");
        const errorState = input.querySelector(".error");
        const text = input.querySelector(".form-element-control");
        if (text) {
            const value = text.value;

            if (characters) {
                characters.textContent = value.length;
            }
            if (errorState) {
                if (value.length === 0) {
                    errorState.classList.add("error-visible");
                    isValid = false;
                } else {
                    errorState.classList.remove("error-visible");
                }
            }
        }

        const select = input.querySelector(".select-selected");
        if (select && errorState) {
            if (select.classList.contains("changed-initial-option")) {
                errorState.classList.remove("error-visible");
            } else {
                errorState.classList.add("error-visible");
                isValid = false;
            }
        }

        const fileInput = input.querySelector("input[type='file']");
        if (fileInput) {
            if (fileInput.files.length === 0) {
                errorState.classList.add("error-visible");
                isValid = false;
            } else {
                errorState.classList.remove("error-visible");
            }
        }
    });

    return isValid;
}

function formOnSubmit(e, form, baseURL) {
    e.preventDefault();

    const inputs = form.querySelectorAll(".form-element-group:has(input), .form-element-group:has(textarea), .form-element-group:has(select)");
    validateForm(inputs);

    if (form.querySelectorAll('.error-visible').length > 0) return;
    // to add animation on error

    form.querySelectorAll('button').forEach(input => {
        input.classList.add('disabled');
    });

    const formData = new FormData();
    formData.append('to', form.querySelector('input[name="formTo"]').value);
    formData.append('subject', form.querySelector('input[name="subject"]').value);
    formData.append('action', 'setForm');

    form.querySelectorAll('input, textarea, select').forEach(input => {
        if (input.classList.contains("search-country")) return;
        if (input.type === 'radio' && !input.checked) return;
        if (input.type === 'checkbox' && input.required) return;
        if (input.type === 'checkbox' && input.checked) {
            formData.append(input.getAttribute('name').toLowerCase().replace(/\s/g, ''), '✅');
            return;
        }
        if (input.type === 'file' && input.value) {
            const files = input.files;
            for (let i = 0; i < files.length; i++) {
                formData.append('file[]', files[i]);
            }
            return;
        }
        if (input.type === 'tel') {
            const countryCode = input.parentElement.parentElement.querySelectorAll('span.active')[0].getAttribute('data-country-tel-code');
            formData.append(input.getAttribute('name').toLowerCase().replace(/\s/g, ''), countryCode + ' ' + input.value);
            return;
        }
        formData.append(input.getAttribute('name').toLowerCase().replace(/\s/g, ''), input.value);
    });

    async function getData() {
        try {
            const response = await fetch(baseURL + '/wp-admin/admin-ajax.php', {
                method: "POST",
                body: formData
            });
            if (!response.ok) {
                let errorMessage = 'An error occurred';
                try {
                    const errorData = await response.json();
                    errorMessage = errorData.data || errorMessage;
                } catch (jsonError) {
                    console.error('Error parsing JSON:', jsonError);
                }

                const errorElement = form.querySelector('.error-message');
                if (errorElement) {
                    errorElement.textContent = errorMessage;
                    errorElement.classList.add('show');
                }

                throw new Error(errorMessage);
            }


            const data = await response.json();

            form.querySelectorAll('input, textarea, select').forEach(input => {
                input.disabled = true;
            });
            const successElement = form.querySelector('.success-message');
            if (successElement) {
                successElement.textContent = data.message || 'Form submitted successfully';
                successElement.classList.add('show');
            }
        } catch (error) {
            console.error('Fetch error:', error);
        }
    }

    getData();
}